<template>
  <div class="flex h-full">
    <PageSidebar
      title=""
      width="w-44"
      bg-class="bg-white"
      :show-collapse-icon="false"
      :items="sidebarItems"
      @item-click="onSidebarClick"
    />
    <div class="flex-1 h-full overflow-y-auto">
      <SuspectRules_AgenticSuspects
        v-if="activeSection === 'agentic'"
      />
      <SuspectRules_RuleManager
        v-if="activeSection === 'rules'"
        :attributes="attributes"
      />
    </div>
  </div>
</template>

<script>
import PageSidebar from '@/components/widgetcomponents/library/PageSidebar.vue';
import SuspectRules_AgenticSuspects from './SuspectRules_AgenticSuspects.vue';
import SuspectRules_RuleManager from './SuspectRules_RuleManager.vue';

export default {
  name: 'SuspectRulesTab',
  components: {
    PageSidebar,
    SuspectRules_AgenticSuspects,
    SuspectRules_RuleManager,
  },
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeSection: 'agentic',
    };
  },
  computed: {
    sidebarItems() {
      return [
        { id: 'agentic', label: 'EHR Agentic Suspects', active: this.activeSection === 'agentic' },
        { id: 'rules', label: 'Suspect Coding Rules', active: this.activeSection === 'rules' },
      ];
    },
  },
  methods: {
    onSidebarClick(item) {
      this.activeSection = item.id;
    },
  },
};
</script>
